const INFIELD_HALF_DIAGONAL = 26;
const INFIELD_CENTER = { x: 50, y: 64 };

export const INFIELD_BASES = {
  C: { x: INFIELD_CENTER.x, y: INFIELD_CENTER.y + INFIELD_HALF_DIAGONAL },
  "1B": { x: INFIELD_CENTER.x + INFIELD_HALF_DIAGONAL, y: INFIELD_CENTER.y },
  "2B": { x: INFIELD_CENTER.x, y: INFIELD_CENTER.y - INFIELD_HALF_DIAGONAL },
  "3B": { x: INFIELD_CENTER.x - INFIELD_HALF_DIAGONAL, y: INFIELD_CENTER.y },
};

const along = (start, end, t) => ({
  x: start.x + (end.x - start.x) * t,
  y: start.y + (end.y - start.y) * t,
});

const offsetAwayFrom = (point, origin, distance) => {
  const dx = point.x - origin.x;
  const dy = point.y - origin.y;
  const length = Math.hypot(dx, dy) || 1;
  return {
    x: point.x + (dx / length) * distance,
    y: point.y + (dy / length) * distance,
  };
};

const infieldHole = (towardBag) =>
  offsetAwayFrom(
    along(INFIELD_BASES["2B"], towardBag, 0.52),
    INFIELD_BASES.C,
    6
  );

export const FIELD_SLOT_POSITIONS = {
  ...INFIELD_BASES,
  "2B": infieldHole(INFIELD_BASES["1B"]),
  P: along(INFIELD_BASES.C, INFIELD_BASES["2B"], 0.48),
  SS: infieldHole(INFIELD_BASES["3B"]),
  LF: { x: 16, y: 26 },
  CF: { x: 50, y: 12 },
  RF: { x: 84, y: 26 },
  DH: { x: 88, y: 90 },
};

export const infieldDiamondPoints = () =>
  [INFIELD_BASES.C, INFIELD_BASES["1B"], INFIELD_BASES["2B"], INFIELD_BASES["3B"]]
    .map((point) => `${point.x},${point.y}`)
    .join(" ");

export const slotPositionSx = (slotId) => {
  const point = FIELD_SLOT_POSITIONS[slotId];
  if (!point) return null;
  return {
    position: "absolute",
    left: `${point.x}%`,
    top: `${point.y}%`,
    transform: "translate(-50%, -50%)",
  };
};
